<template>
    <v-app pb-3>
        <v-content>
            <v-form>
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap>
                        <v-flex xs12 pb-5>
                            <a href="/dashboard">Личный кабинет</a>
                        </v-flex>
                        <v-flex xs12 md10>
                            <h1>Сервисы</h1>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container style="max-width: 1200px;">
                    <v-layout wrap row>
                        <v-flex class="service-item" xs12 sm6 v-for="(service, key) in services" :key="key" v-show="service.show">
                            <span v-if="service.count" class="kbm-badge">{{service.count}}</span>
                            <a class="service-link"
                                :href="service.link"
                                v-html="service.name"/>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    props: {
        freeRecoveries: {
            default: 0
        },
        user: {
            default: {}
        }
    },
    created() {
        this.services = [
            {
                name: 'Восстановление КБМ',
                link: '/kbm-list',
                count: this.freeRecoveries,
                show: false,
            },
            {
                name: 'Оформление договора купли-продажи',
                link: '/services/sales-contract',
                show: true,
            },
            {
                name: 'Скачать извещение о ДТП',
                link: '/downloads/DTP.doc',
                show: true,
            },
            {
                name: 'Настройка банковских продуктов',
                link: '/bp/settings',
                show: this.user.user_type === 'admin',
            },
            {
                name: 'Счётчик BAD',
                link: '/stats/parser/BAD',
                show: this.user.user_type === 'admin',
            },
            {
                name: 'Поиск и проверка полиса по базе РСА',
                link: '/services/', 
                show: false, 
            },
            {
                name: 'Поиск данных ТС по базе ГИБДД',
                link: '/services/gibdd',
                show: false,
            },
            {
                name: 'Поиск данных по базе ЕАИСТО',
                link: '/services/dcard',
                show: false,
            }
        ]
    },
    data: () => ({
        services: [],
    })
}
</script>

<style scoped>
    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }
    .service-item {
        width: 100%;
        position: relative;
    }
    @media (max-width: 576px) {
        .kbm-badge {
            top: 32px;
        }
    }
    @media (min-width: 577px) {
        .service-item {
            height: 250px;
        }
        .kbm-badge {
            top: 200px;
        }
    }

    .service-item:hover {
        -webkit-filter: brightness(95%);
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        transition: all 0.5s ease;
    }

    .service-link {
        display: block;
        background-color: #f1f2f3;
        border-radius: 12px;
        width: 100%;
        height: 100%;
        color: black;
        text-decoration: none;
        font-family: 'SFUIDisplay', Arial, sans-serif;
        font-size: 26px;
        padding: 20px;
    }

    .kbm-badge {
        font-family: 'SFPro';
        font-weight: 700;
        font-size: 14px;
        color: #fff !important;
        background: #00ba57;
        border-radius: 50%;
        max-width: 32px;
        max-height: 32px;
        min-width: 32px;
        min-height: 32px;
        width: 32px;
        height: 32px;
        padding: 6px;
        text-align: center;
        vertical-align: middle;
        display: table-cell;
        position: absolute;
        right: 20px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/Services.vue